// A safer version of the Extract Utility Type
export type SafeExtract<T, K extends keyof T> = K;

/**
 * Helper function for ensuring all cases are hanlded in a switch/case statment.
 *
 * @example
 *     const x: 'a' | 'b' = 'a';
 *     switch (x) {
 *       case 'a':
 *         console.log('a');
 *         break;
 *       case 'b':
 *         console.log('b');
 *         break;
 *       default:
 *         // This will compile-time error if some cases are not handled.
 *         assertNever(x);
 *     }
 */
export function assertNever(x: never): never {
  throw new Error('Unexpected object: ' + x);
}

// string literal utility type to infer the types of a delimited string's parts
export type InferParts<
  T extends string,
  D extends string,
> = T extends `${infer FirstPart}${D}${infer Rest}` ? [FirstPart, ...InferParts<Rest, D>] : [T];
export type NthPart<T extends any[], N extends number> = T[N];

// function to get the part of a string delimited input value
export const getNthPart = <T extends string, D extends string, N extends number>(
  input: T,
  delimiter: D,
  index: N,
): NthPart<InferParts<T, D>, N> => {
  const parts = input.split(delimiter) as InferParts<T, D>;
  return parts[index];
};
